import type { JSX } from 'react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TimeframeControls as SharedTimeframeControls } from '@feathr/report_components';

import type { TDateRange, TTimeframePreset } from '../ReportsConversionsDashboardPage.utils';
import { buildPresetOptions } from './TimeframeControls.utils';

export interface ITimeframeControlsProps {
  preset: TTimeframePreset;
  range: TDateRange;
  onPresetChange: (preset: TTimeframePreset) => void;
  onRangeChange: (range: TDateRange) => void;
}

function TimeframeControls({
  preset,
  range,
  onPresetChange,
  onRangeChange,
}: Readonly<ITimeframeControlsProps>): JSX.Element {
  const { t } = useTranslation();
  const options = useMemo(() => buildPresetOptions(t), [t]);

  return (
    <SharedTimeframeControls
      onPresetChange={onPresetChange}
      onRangeChange={onRangeChange}
      options={options}
      preset={preset}
      range={range}
    />
  );
}

export default TimeframeControls;
